module.exports = __webpack_public_path__ + "f97dbc00526098c28d1e68d6a26cf1cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/4/Assets/img1.jpeg
// module id = 1357
// module chunks = 0